import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ReleasePage } from './ReleasePage';

/**
 * The song page route (`/app/promote/promoteRelease?catalogItemUuid=<uuid>&tab=assets|plan`, spec
 * D25, design m2). Every call is account-scoped; the key starts a new page for each artist.
 */
const ReleasePageScreenComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <ReleasePage key={accountId} accountId={accountId} />;
};

export const ReleasePageScreen = TypedMemo(ReleasePageScreenComponent);
